import styles from './boardingRoles.module.scss'

const OnBoardingRoles = ({ renderForm }) => {
	return (
		<>
			<div className={styles.onboardingRoles}>{renderForm()}</div>
		</>
	)
}

export default OnBoardingRoles
